import { SlideSection as bdtv_8380acc1d802 } from "@Bondit2Theme/mod-kotapa";
import { LazyLoader as bdtv_d35bbc0698e0 } from "@Bondit2Theme/mod-fipefi";
import * as bdtv_b9cb92426e92 from "@Bondit2Theme/mod-fozane";
import { eventModal as bdtv_fe06ca29b232 } from "@Bondit2Theme/mod-kodati";

class bdtv_2464ca8fb061 extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.bdtFaixaVopa;
    this.input = this.querySelector('input[type="search"]');
    this.form = this.querySelector("form#search_mini_form");
    this.templateRecommendedDefault = this.querySelector(".bdt-zovi-bika-kako"
    );
    this.templateRecommendedPopup = this.querySelector(".bdt-zovi-bika-balao"
    );
    this.predictiveSearchResults = this.querySelector(".bdt-bedi-busca2");
    this.searchKeyword = this.querySelector(".bdt-busca2-modi");
    this.recommendSearch = this.querySelector(".bdt-dapo-busca2");
    this.input?.addEventListener(
      "input",
      bdtv_b9cb92426e92.debounce((bdtv_e8ac69e2d4e5) => {
        this.onInput(bdtv_e8ac69e2d4e5);
      }, 300).bind(this)
    );
    this.input.addEventListener("click", this.hideAnimationText.bind(this));
    window.Shopify.designMode &&
      (document.addEventListener("shopify:section:select", (bdtv_dfa7302ad5ab) => {
        const bdtv_10d4ea4fba48 = bdtv_dfa7302ad5ab.target;
        if (
          JSON.parse(bdtv_10d4ea4fba48.dataset.shopifyEditorSection).id ===
          this.sectionId
        ) {
          bdtv_fe06ca29b232(this, "open", false);
          if (this.querySelector(".bdt-busca2-dela") && this.querySelector(".bdt-busca2-dela").classList.contains("bdt-oculto2-leda")) {
            setTimeout(() => this.input.focus(), 10);
          }
        }
      }),
      document.addEventListener("shopify:section:deselect", () => {
        const bdtv_1f6b41867464 = document.querySelector("bdt-rine-busca2");
        if (bdtv_1f6b41867464) {
          bdtv_fe06ca29b232(bdtv_1f6b41867464, "close", false);
        }
      }));
  }

  get actionSearch() {
    return document.querySelector("#search-icon-bubble") || null;
  }

  get type() {
    return this.getAttribute("data-bdt-ga");
  }

  connectedCallback() {
    if (this.actionSearch) {
      this.actionSearch.addEventListener("click", (bdtv_5a02d0190aa2) => {
        bdtv_5a02d0190aa2.preventDefault();
        if (
          this.recommendSearch &&
          this.recommendSearch.querySelector("template") &&
          this.templateRecommendedDefault
        ) {
          this.updateProductRecommended();
        }
        bdtv_fe06ca29b232(this, "open", false);
        setTimeout(() => this.input.focus(), 10);
        bdtv_b9cb92426e92.global.rootToFocus = this.actionSearch;
      });
    }
    if (this.type == "popup") {
      this.innerWidth();
    }
  }

  innerWidth() {
    let bdtv_2b7b39d70d45 = window.innerWidth;
    window.addEventListener("resize", () => {
      const bdtv_0a4f39b11153 = window.innerWidth;
      if (bdtv_0a4f39b11153 <= 1024 && bdtv_2b7b39d70d45 > 1024) {
        this.actionSearchMobile();
      }
      if (bdtv_0a4f39b11153 > 1024 && bdtv_2b7b39d70d45 <= 1024) {
        this.actionSearchDesktop();
      }
      bdtv_2b7b39d70d45 = bdtv_0a4f39b11153;
    });
    if (bdtv_2b7b39d70d45 <= 1024) {
      this.actionSearchMobile();
    } else {
      this.actionSearchDesktop();
    }
  }

  updateProductRecommended() {
    if (
      this.classList.contains("bdt-busca2-ga-balao") &&
      this.templateRecommendedPopup
    ) {
      const bdtv_b2432e6e6359 = document.createElement("div");
      bdtv_b2432e6e6359.appendChild(
        this.templateRecommendedPopup.content.firstElementChild.cloneNode(true)
      );
      this.recommendSearch.innerHTML = bdtv_b2432e6e6359.innerHTML;
    } else {
      const bdtv_ebe66594bb64 = document.createElement("div");
      bdtv_ebe66594bb64.appendChild(
        this.templateRecommendedDefault.content.firstElementChild.cloneNode(
          true
        )
      );
      this.recommendSearch.innerHTML = bdtv_ebe66594bb64.innerHTML;
    }
    this.recommendSearch.classList.add("update-recommended");
    new bdtv_d35bbc0698e0(".bdt-figura-zora-no");
  }

  actionSearchMobile() {
    this.classList.remove("bdt-busca2-ga-balao");
    this.classList.add("bdt-busca2-ga-gaveta");
    this.onInput();
    if (
      this.templateRecommendedDefault &&
      this.recommendSearch.classList.contains("update-recommended")
    ) {
      this.updateProductRecommended();
    }
  }

  actionSearchDesktop() {
    this.classList.remove("bdt-busca2-ga-gaveta");
    this.classList.add("bdt-busca2-ga-balao");
    this.onInput();
    if (
      this.templateRecommendedDefault &&
      this.recommendSearch.classList.contains("update-recommended")
    ) {
      this.updateProductRecommended();
    }
  }

  onInput() {
    this.hideAnimationText();
    const bdtv_78c222470d91 = this.input.value.trim();
    if (!bdtv_78c222470d91.length) {
      this.form.classList.remove("bdt-roge", "on-input", "bdt-carregando2");
      bdtv_b9cb92426e92.trapFocus(this);
      return;
    }
    let bdtv_6544e680ddcb = "bdt-bedi-busca2-gaveta";
    if (this.classList.contains("bdt-busca2-ga-balao")) {
      bdtv_6544e680ddcb = "bdt-bedi-busca2-balao";
    }
    this.form.classList.add("bdt-carregando2", "on-input");
    if (this.predictiveSearchResults) {
      this.getSearchResults(bdtv_78c222470d91, bdtv_6544e680ddcb); 
      return;
    }
    bdtv_b9cb92426e92.trapFocus(this);
  }

  getSearchResults(bdtv_8addae8c9381, bdtv_7d17d252eb54) {
    const bdtv_4f05e294a9c9 = `${routes.predictive_search_url}?q=${encodeURIComponent(
      bdtv_8addae8c9381
    )}&section_id=${bdtv_7d17d252eb54}&resources[limit]=10&resources[limit_scope]=each`;
    fetch(bdtv_4f05e294a9c9)
      .then((bdtv_59a4dbf112dc) => {
        if (!bdtv_59a4dbf112dc.ok) {
          var bdtv_a3f5a0558aeb = new Error(bdtv_59a4dbf112dc.status);
          this.form.classList.remove("bdt-carregando2", "bdt-roge");
          throw bdtv_a3f5a0558aeb;
        }
        return bdtv_59a4dbf112dc.text();
      })
      .then((bdtv_8757026faacf) => {
        const bdtv_ffd5df96b59c = new DOMParser()
          .parseFromString(bdtv_8757026faacf, "text/html")
          .querySelector(`#shopify-section-${bdtv_7d17d252eb54}`)?.innerHTML;
        if (this.predictiveSearchResults) {
          this.predictiveSearchResults.innerHTML = bdtv_ffd5df96b59c;
        }
        this.form.classList.remove("bdt-carregando2");
        this.form.classList.add("bdt-roge");
        if (this.querySelectorAll(".bdt-vo-voge-atalho").length > 0) {
          this.querySelectorAll(".bdt-vo-voge-atalho").forEach((bdtv_287d75a8a945) => {
            bdtv_287d75a8a945.href = `${routes.search_url}?q=${encodeURIComponent(
              bdtv_8addae8c9381
            )}&options%5Bprefix%5D=last`;
          });
        }
        bdtv_b9cb92426e92.trapFocus(this);
      })
      .catch((bdtv_3f2b6a17eb6f) => {
        this.form.classList.remove("bdt-carregando2", "bdt-roge");
        throw bdtv_3f2b6a17eb6f;
      });
  }

  hideAnimationText() {
    if (this.querySelector(".bdt-busca2-dela")) {
      this.querySelector(".bdt-busca2-dela").classList.add("bdt-oculto2-leda");
    }
  }
}
customElements.define("bdt-rine-busca2", bdtv_2464ca8fb061);

class bdtv_2cd13de0fec4 extends HTMLElement {
  constructor() {
    super();
    Motion.inView(this, this.init.bind(this));
  }

  async init() {
    await this.animation(this.getAttribute("data-bdt-verbo"));
  }

  async animation(bdtv_e4e85d967e49) {
    (this.innerHTML = bdtv_e4e85d967e49),
      await Motion.animate(
        this,
        {
          width: [0, `${this.scrollWidth + 1}px`],
        },
        {
          duration: 0.7,
          delay: 0.5,
        }
      ).finished,
      this.closest(".bdt-busca2-dela")
        .querySelector(".bdt-verbo-cursor")
        .classList.remove("bdt-oculto2-leda");
  }
}
customElements.define("bdt-busca2-verbo", bdtv_2cd13de0fec4);
